import React, { Suspense, useEffect } from 'react';
import { Canvas, useLoader } from '@react-three/fiber';
import { OrbitControls, useGLTF, Environment } from '@react-three/drei';
import * as THREE from 'three';

// Create a single, reusable placeholder texture.
// const placeholderTexture = new THREE.CanvasTexture(document.createElement('canvas'));

// This component contains the actual 3D model logic.
const LoadedModel = ({ selection, sizeData }) => {
    const { scene } = useGLTF(sizeData.glb);
    const { scene: baseScene } = useGLTF(selection.base);

    const structureTexturePath = (selection.structureColor?.texture  && !selection.structureColor?.texture.startsWith('0x'))
        ? (window.CRBVars.reactAppUri + selection.structureColor.texture)
        : '/materials/structure/wood.jpeg';

    const usingNum = selection.canopyColor?.texture.length === 4;

    console.log(selection.canopyColor)
    const canopyTexturePaths = selection.canopyColor ? (usingNum
          ? [
              '/materials/' + selection.canopyColor.texture + '/PBRTextures/' + selection.canopyColor.texture + '_BASE.jpg',
              '/materials/' + selection.canopyColor.texture + '/PBRTextures/' + selection.canopyColor.texture + '_ROUGH.jpg',
              '/materials/' + selection.canopyColor.texture + '/PBRTextures/' + selection.canopyColor.texture + '_NRM.jpg'
            ]
          : [window.CRBVars.reactAppUri + selection.canopyColor?.texture]) : ['/materials/fabrics2/canvas-sky-blue.jpg'];
    console.log(canopyTexturePaths)
    const [structureTexture, ...canopyTextures] = useLoader(THREE.TextureLoader, [
        structureTexturePath,
        ...canopyTexturePaths
    ]);
    const [baseColorTex, roughnessTex, normalTex] = usingNum ? canopyTextures : [null, null, null];
    const canopyTexture = usingNum ? baseColorTex : canopyTextures[0];

    useEffect(() => {
        if (structureTexture) {
            structureTexture.wrapS = THREE.RepeatWrapping;
            structureTexture.wrapT = THREE.RepeatWrapping;
            structureTexture.repeat.set(0.05, 0.05); // Adjust based on visual scale
            structureTexture.anisotropy = 16;
            structureTexture.needsUpdate = true;
        }
    }, [structureTexture]);

    // useEffect(() => {
    //     if (canopyTexture) {
    //         canopyTexture.wrapS = THREE.RepeatWrapping;
    //         canopyTexture.wrapT = THREE.RepeatWrapping;
    //         canopyTexture.repeat.set(0.05, 0.05); // Repeat a few times so it looks fabric-like
    //         canopyTexture.anisotropy = 16;
    //         canopyTexture.needsUpdate = true;
    //     }
    // }, [canopyTexture]);

    useEffect(() => {
        if (usingNum) {
          console.log('Using num');
          const repeat = 0.0333333351;
          [baseColorTex, roughnessTex, normalTex].forEach(tex => {
            tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
            tex.repeat.set(repeat, repeat);
            tex.anisotropy = 16;
            tex.needsUpdate = true;
          });
        } else if (canopyTexture) {
          canopyTexture.wrapS = canopyTexture.wrapT = THREE.RepeatWrapping;
          canopyTexture.repeat.set(0.05, 0.05);
          canopyTexture.anisotropy = 16;
          canopyTexture.needsUpdate = true;
        }
      }, [baseColorTex, roughnessTex, normalTex, canopyTexture, usingNum]);

    useEffect(() => {
        if (!scene) return;
        scene.visible = true;
        if (baseScene) {
            baseScene.visible = true;
        }
        scene.traverse((child) => {
            if (child.isMesh && child.name === 'structure') {
                console.log('structure UVs:', child.geometry.attributes.uv);
            }
            if (child.isMesh && child.name === 'Top') {
                console.log('canopy UVs:', child.geometry.attributes.uv);
            }
            
            if (child.isMesh) {
                
                const name = child.name;

                if (name === "Bumpers" || name === "Final_Cap") {
                    child.material.color.setHex(0x000000);
                }

                if (name === "Stitches") {
                    child.material.color.setHex(0xFFFFFF);
                }

                if (name === 'structure' || name === 'Structure') {
                    if (selection.structureColor?.texture.startsWith('0x')) {
                        child.material = new THREE.MeshStandardMaterial({
                            color: selection.structureColor.texture.replace('0x', '#'),
                            roughness: 0.1,
                            metalness: 0.2,
                        });
                    } else {
                        child.material = new THREE.MeshStandardMaterial({
                            map: structureTexture,
                            roughness: 0.1,
                            metalness: 0.2,
                        });
                    }
                }
                // } else if (name === 'Structure') {
                //     // console.dir(child.material, { depth: null });
                //     if (selection.structureColor?.texture.startsWith('0x')) {
                //         // child.material.map = defaultStructureTexture;
                //         child.material.color.setHex(selection.structureColor.texture);
                //         child.material.roughness = 0.2;
                //         child.material.metalness = 0.7;
                //     }   
                //     // console.dir(child.material, { depth: null });
                //     child.material.needsUpdate = true;
                // }

                if (name === "Crank_1") {
                    child.material.roughness = 0.1;
                    child.material.metalness = 0.5;
                }

                if (name === 'Top') {
                    if (usingNum) {
                      child.material = new THREE.MeshStandardMaterial({
                        map: baseColorTex,
                        roughnessMap: roughnessTex,
                        normalMap: normalTex,
                        side: THREE.DoubleSide
                      });
                    } else {
                      child.material = new THREE.MeshStandardMaterial({
                        map: canopyTexture,
                        roughness: 0.8,
                        metalness: 0.0,
                        side: THREE.DoubleSide,
                        envMapIntensity: 50
                      });
                    }
                    child.material.needsUpdate = true;
                }

                const isValance = name.includes('Valance') || name.includes('Valence');
                const isFringe = name.includes('Fringe');
                const isFringePipe = name.includes('Pipe') || name.includes('Binding');

                if (isValance || isFringe || isFringePipe) {
                    child.visible = false;
                }

                if (selection.valance) {
                    if (name === selection.valance.id) {
                        child.visible = true;
                        child.material = new THREE.MeshStandardMaterial({
                            map: canopyTexture,
                            roughness: 0.8,
                            metalness: 0.0,
                            side: THREE.DoubleSide
                        });
                        child.material.needsUpdate = true;
                    }

                    if (selection.hasFringe && name === selection.valance.fringeId) {
                        child.visible = true;
                        child.material.opacity = 0.6;
                        child.material.transparent = true;
                    }

                    if (name === selection.valance.pipeId) {
                        child.visible = true;
                        child.material.color.setHex(0xFFFFFF);
                        child.material.roughness = 0.1; 
                        child.material.metalness = 0.1;
                        child.material.needsUpdate = true;
                    }
                } else if (name === 'Pipe' || name === 'Binding') {
                    child.visible = true;
                    child.material.color.setHex(0xFFFFFF);
                    child.material.roughness = 0.1; 
                    child.material.metalness = 0.1;
                    child.material.needsUpdate = true;
                }
            }
        });
    }, [scene, baseScene, selection, structureTexture, canopyTexture, usingNum, baseColorTex, roughnessTex, normalTex ]);

    return (
        <>
            <primitive object={scene} position={[0, -1, 0]} />
            {sizeData.name === "40x40 NEW 7/22" ?
                <primitive object={baseScene} position={[-1.7, -1.07, 0]} />
                :
                <primitive object={baseScene} position={[-1.75, -1, 0]} />
            }
        </>
    );
};
// This component decides whether to render the model or not.
const Model = ({ selection, configData }) => {
    const modelData = configData.models.find(m => m.name === selection.model);
    const sizeData = modelData?.sizes.find(s => s.name === selection.size);

    if (!sizeData?.glb) {
        return null;
    }

    return <LoadedModel selection={selection} sizeData={sizeData} />;
};

// The main Configurator component that sets up the 3D canvas and environment
const Configurator = ({ selection, configData }) => {
    return (
        <div className="canvas-container" style={{ width: '100%', height: '100%' }}>
            <Canvas camera={{ fov: 15, position: [-18, 6, 15] }}>
                <Environment files={'./studio.hdr'} />
                {/* <directionalLight 
                            position={[0, 0, 0]} 
                            intensity={1.6} 
                            color="#ffffff"
                            castShadow={true}
                            shadow-mapSize-width={2048}
                            shadow-mapSize-height={2048}
                /> */}
                {/* <ambientLight intensity={0.5} /> */}
                {/* <directionalLight position={[100, 30, 30]} intensity={0.6} /> */}
                {/* <spotLight position={[100, 100, 10]} angle={0.3} penumbra={1} intensity={100} /> */}
                {/* <pointLight position={[-10, -10, -10]} intensity={100} /> */}
                
                <Suspense fallback={null}>
                    <Model selection={selection} configData={configData} />
                </Suspense>
                
                <OrbitControls />
            </Canvas>
        </div>
    );
};

export default Configurator;